export default {
  sequenceReport : null
};
